import React, {useState} from "react";
import {Button, Divider, Drawer, Layout, Menu, Tooltip, Typography} from "antd";
import {MenuFoldOutlined, MenuOutlined, MenuUnfoldOutlined} from "@ant-design/icons";
import "./NavBar.css";
import useController from "./BasicHeader.controller";
import HeaderDropdown from "../../layout/HeaderDropdown/HeaderDropdown";
import ThemeMenu from "./components/ThemeMenu";
import {Link, withRouter} from "react-router-dom";
import ExpandedLogoDarkMode from "../../layout/SideMenu/assets/side_menu_logo_expanded_dark_mode.png";
import ExpandedLogo from "../../layout/SideMenu/assets/side_menu_logo_expanded.png";
import DynamicIcon from "../../components/DynamicIcon";

const {Title} = Typography;
const {Header} = Layout;
const {SubMenu} = Menu;

const NavBar = ({location, className, user, userData, menuItems, dropdownItems, applicationName, children, menu, theme, darkMode, primaryColor}) => {
    const {collapsed, setCollapsed, changeTheme, changePrimaryColor} = useController();
    const [visible, setVisible] = useState(false);

    const path = location.pathname;
    const item = path !== "/" ? path.substr(1) : menuItems[0].key || null;

    const renderMenuItem = ({key, icon, value, divider}) => {
        return divider ?
            <Menu.ItemGroup key={value} title={
                <Divider>{value}</Divider>}/> : (
                <Menu.Item key={key}>
                    <Link to={`/${key}`}> {icon && <DynamicIcon size={'large'} type={icon}/>}
                        <span>{value}</span>
                    </Link>
                </Menu.Item>
            );
    };

    const renderMenuItems = () => {
        const items = menuItems || [];
        return items.map(item => {
            if (!item.subItems || item.subItems.length === 0) {
                return item.hideFromMenu ? null : renderMenuItem(item);
            } else {
                return (
                    <SubMenu
                        key={item.key}
                        title={
                            <span>
                                <span>{item.value}</span>
                            </span>
                        }
                    >
                        {item.subItems.map(subItem => renderMenuItem(subItem))}
                    </SubMenu>
                );
            }
        });
    };

    return (
        <>
            <Header className={`container ${className}`} style={{backgroundColor: '#ffffff'}}>
                <span className={'header-container'}>
                    <Link to={'/'}><Title level={5}
                                          style={{position: 'relative', top: 5}}>{applicationName}</Title></Link>
                    &nbsp;<Button
                    className="menu"
                    type="primary"
                    size='small'
                    icon={visible ? <MenuOutlined/> : <MenuOutlined/>}
                    onClick={() => setVisible(true)}
                /></span>

                <Drawer className={'navbar-drawer ' + (darkMode && 'dark-mode')} width={215}
                        title={<Link to={'/'} className="logo-wrapper">
                            <img src={darkMode ? ExpandedLogoDarkMode : ExpandedLogo} alt="logo"
                                 className="side-menu-logo"/>
                        </Link>}
                        placement="left"
                        onClick={() => setVisible(false)}
                        onClose={() => setVisible(false)}
                        visible={visible}
                >
                    <Menu theme={theme} defaultSelectedKeys={[item]} mode="inline">
                        {renderMenuItems()}
                    </Menu>
                </Drawer>

                <span className='right-side'> {children}
                    <HeaderDropdown user={user} userData={userData} menuItems={dropdownItems} darkMode={darkMode}/>

                    <Tooltip title='Theme settings'>
                        <Button size='small' type="primary" onClick={setCollapsed}>
                            {collapsed ? <MenuFoldOutlined/> : <MenuUnfoldOutlined/>}
                        </Button></Tooltip>
                </span>
            </Header>

            <ThemeMenu theme={theme} darkMode={darkMode} primaryColor={primaryColor} collapsed={collapsed}
                       setCollapsed={setCollapsed}
                       changeTheme={changeTheme} changePrimaryColor={changePrimaryColor}/>
        </>
    );
};

export default withRouter(NavBar);
